import './partials/login';

// Set global event listener object
window.globalAccountsEvents = {};
